import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import WysiwygText from '@components/_shared/wysiwygText';

import styles from './styles.module.scss';

type Props = {
  question: string;
  answerRaw: any;
  isSelected: boolean;
  index: number;
  onClick: (index: number) => void;
} & BaseComponentProps;

const FAQ = (props: Props) => {
  const { index, isSelected, onClick, question, answerRaw, containerStyle } =
    props;

  return (
    <div
      className={clsx([styles.faq, isSelected && styles.open, containerStyle])}
      onClick={() => onClick(index)}
    >
      <h3 className={styles.faq__question}>{question}</h3>
      <h4 className={styles.faq__answer}>
        {typeof answerRaw === 'string' ? (
          answerRaw
        ) : (
          <WysiwygText content={answerRaw} />
        )}
      </h4>
    </div>
  );
};

export default FAQ;
